@if (this.formControl?.disabled) {
    <!-- sometimes only unitIdentifier is in documentLineItem - thats why we dont use unitDropDownComponent -->
    <input
        pInputText
        [style.width]="'100%'"
        [value]="documentLineItem()?.unitIdentifier"
        [disabled]="true"
    />
} @else {
    <app-dli-unit-conversion-drop-down
        [(value)]="value"
        [(documentLineItem)]="documentLineItem"
        [(baseUnitIdentifier)]="baseUnitIdentifier"
        [(documentDirection)]="documentDirection"
        [(skipLoadUnitConversions)]="skipLoadUnitConversions"
        [(focusedIndex)]="focusedIndex"
        [(minFractionDigits)]="minFractionDigits"
        [(items)]="unitConversions"
        [disabled]="formControl?.disabled ?? false"
    ></app-dli-unit-conversion-drop-down>
}
